// Module
var code = "<hero></hero><discoveremerson ng-if=\"$ctrl.showSecondaryContent \"></discoveremerson><supportforyourpractice ng-if=\"$ctrl.showSecondaryContent \"></supportforyourpractice><valuepropbar ng-if=\"$ctrl.showSecondaryContent \"></valuepropbar><welcome-splash ng-if=\"$ctrl.showSecondaryContent \"></welcome-splash>";
// Exports
module.exports = code;